const mediaItems = [
  {
    title: '鬼灭之刃 柱训练篇',
    desc: '炭治郎一行人前往参加柱合训练，迎接最终决战前的严酷考验',
    tag: '热播中',
    episodes: '更新至第6集',
    views: '1280万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20scene%20with%20vibrant%20color%20palette%2C%20dynamic%20action%20composition%2C%20anime%20characters%20in%20dramatic%20pose%2C%20cinematic%20lighting%20with%20warm%20highlights%2C%20clean%20flat%20background%20with%20subtle%20gradient%2C%20Japanese%20animation%20aesthetic%2C%20no%20text%20no%20watermark&width=640&height=360&seq=media-card-01&orientation=landscape',
  },
  {
    title: '迷宫饭 第二季',
    desc: '莱欧斯小队继续深入迷宫，用魔物烹饪出令人惊叹的地下城美食',
    tag: '本周新番',
    episodes: '更新至第3集',
    views: '860万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20with%20warm%20earthy%20tones%2C%20fantasy%20adventure%20scene%20with%20characters%20cooking%20in%20a%20dungeon%2C%20cozy%20atmosphere%2C%20soft%20cinematic%20lighting%2C%20clean%20flat%20animation%20style%2C%20detailed%20food%20illustration%2C%20no%20text%20no%20watermark&width=640&height=360&seq=media-card-02&orientation=landscape',
  },
  {
    title: '时光代理人 第三季',
    desc: '程小时和陆光再次穿越时空，揭开隐藏在照片背后的惊天秘密',
    tag: '国创精品',
    episodes: '全12集',
    views: '2150万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20animation%20style%20illustration%2C%20urban%20mystery%20theme%20with%20two%20young%20men%2C%20time%20travel%20concept%20with%20photo%20visuals%2C%20dramatic%20lighting%20with%20cool%20and%20warm%20contrast%2C%20clean%20flat%20directional%20style%2C%20no%20text%20no%20watermark&width=640&height=360&seq=media-card-03&orientation=landscape',
  },
  {
    title: 'Re:从零开始的异世界生活 第三季',
    desc: '菜月昴面对新的死亡回归循环，在水门都市展开惊心动魄的冒险',
    tag: '经典续作',
    episodes: '更新至第8集',
    views: '1620万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20fantasy%20illustration%20with%20dramatic%20dark%20fantasy%20tone%2C%20male%20protagonist%20in%20medieval%20fantasy%20setting%2C%20atmospheric%20lighting%20with%20deep%20shadows%2C%20emotional%20dramatic%20composition%2C%20clean%20flat%20Japanese%20animation%20style%2C%20no%20text%20no%20watermark&width=640&height=360&seq=media-card-04&orientation=landscape',
  },
];

export default function SectionMedia() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">精选推荐</h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-8 md:mb-10">本周最值得追的高清动漫番剧精选</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <div key={i} className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 transition-all duration-300 hover:border-primary-200 cursor-pointer">
              <div className="relative aspect-video bg-background-200 overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) target.parentElement.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 bg-accent-500 text-background-50 rounded-md text-xs font-semibold">{item.tag}</span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-background-50 text-xl md:text-2xl" style={{ width: '1em', height: '1em' }}></i>
                  </div>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1 line-clamp-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 mb-2 line-clamp-2 leading-relaxed">{item.desc}</p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{item.episodes}</span>
                  <span className="flex items-center gap-1"><i className="ri-eye-line" style={{ width: '1em', height: '1em' }}></i>{item.views}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}